import { useTranslation } from 'react-i18next';
import Icon from '#app/assets/favicons/android-chrome-192x192.png';
import Icon01 from '#app/assets/images/pricing-icon-01.svg';
import Icon02 from '#app/assets/images/pricing-icon-02.svg';
import Icon03 from '#app/assets/images/pricing-icon-03.svg';
import Icon05 from '#app/assets/images/pricing-icon-05.svg';
import Icon06 from '#app/assets/images/pricing-icon-06.svg';
import Icon07 from '#app/assets/images/pricing-icon-07.svg';
import IllustrationTop from '#app/assets/images/pricing-illustration-top.svg';
import Illustration from '#app/assets/images/pricing-illustration.svg';
import Particles from '#app/components/particles.tsx';

export default function Features05() {
	const { t } = useTranslation();

	return (
		<section className="relative">
			{/* Particles animation */}
			<div className="absolute left-1/2 top-0 -z-10 -mt-24 h-64 w-64 -translate-x-1/2">
				<Particles
					className="absolute inset-0 -z-10"
					quantity={6}
					staticity={30}
				/>
			</div>

			<div className="mx-auto max-w-6xl px-4 sm:px-6">
				<div className="pb-12 md:pb-20">
					{/* Section header */}
					<div className="mx-auto max-w-3xl pb-12 text-center">
						<h2 className="h2 bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 bg-clip-text pb-4 text-transparent">
							{t('features6.technology')}
						</h2>
					</div>

					{/* Rings illustration */}
					<div className="pb-8 text-center">
						<div className="relative inline-flex items-center justify-center">
							{/* Particles animation */}
							<Particles className="absolute inset-0 -z-10" quantity={10} />
							<div className="inline-flex">
								<img
									src={Illustration}
									width="334"
									height="334"
									alt="Features illustration"
								/>
							</div>
							<img
								className="absolute -mt-[40%]"
								src={IllustrationTop}
								width="396"
								height="328"
								alt="Features illustration top"
								aria-hidden="true"
							/>
							<div className="absolute flex w-[300%] items-center justify-center space-x-5">
								<div className="-rotate-[4deg]">
									<img
										className="h-11 w-11 animate-[float_2.6s_ease-in-out_infinite] opacity-20 drop-shadow-lg"
										src={Icon01}
										width={80}
										height={80}
										alt="Pricing icon 01"
									/>
								</div>
								<div className="rotate-[4deg]">
									<img
										className="h-14 w-14 animate-[float_2.4s_ease-in-out_infinite] opacity-25 drop-shadow-lg"
										src={Icon02}
										width={80}
										height={80}
										alt="Pricing icon 02"
									/>
								</div>
								<div className="-rotate-[4deg]">
									<img
										className="h-16 w-16 animate-[float_2.2s_ease-in-out_infinite] opacity-60 drop-shadow-lg"
										src={Icon03}
										width={80}
										height={80}
										alt="Pricing icon 03"
									/>
								</div>
								<div className="mb-8 animate-float rounded-3xl bg-gradient-to-b from-slate-300/20 to-transparent p-px">
									<img
										className="rounded-3xl drop-shadow-lg"
										src={Icon}
										width={100}
										height={100}
										alt="Pricing icon 04"
									/>
								</div>
								<div className="rotate-[4deg]">
									<img
										className="h-16 w-16 animate-[float_2.2s_ease-in-out_infinite] opacity-60 drop-shadow-lg"
										src={Icon05}
										width={80}
										height={80}
										alt="Pricing icon 05"
									/>
								</div>
								<div className="-rotate-[4deg]">
									<img
										className="h-14 w-14 animate-[float_2.4s_ease-in-out_infinite] opacity-25 drop-shadow-lg"
										src={Icon06}
										width={80}
										height={80}
										alt="Pricing icon 06"
									/>
								</div>
								<div className="rotate-[4deg]">
									<img
										className="h-11 w-11 animate-[float_2.6s_ease-in-out_infinite] opacity-20 drop-shadow-lg"
										src={Icon07}
										width={80}
										height={80}
										alt="Pricing icon 07"
									/>
								</div>
							</div>
						</div>
					</div>

					{/* Features list */}
					<div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
						{/* Card #1 */}
						<div className="rounded-3xl border border-slate-800 bg-gradient-to-tr from-slate-800/50 to-slate-800/10">
							<div className="flex h-full items-center space-x-4 p-4">
								<svg
									className="shrink-0"
									xmlns="http://www.w3.org/2000/svg"
									width="20"
									height="20"
								>
									<path
										className="fill-teal-500"
										fillOpacity=".24"
										d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0Z"
									/>
									<path
										className="fill-teal-400"
										fillRule="nonzero"
										d="M13 6.586 14.414 8l-5.747 5.748-3.081-3.081L7 9.252l1.667 1.667z"
									/>
								</svg>
								<p className="text-sm text-slate-400">
									{t('features6.card1.text')}
								</p>
							</div>
						</div>
						{/* Card #2 */}
						<div className="rounded-3xl border border-slate-800 bg-gradient-to-tr from-slate-800/50 to-slate-800/10">
							<div className="flex h-full items-center space-x-4 p-4">
								<svg
									className="shrink-0"
									xmlns="http://www.w3.org/2000/svg"
									width="20"
									height="20"
								>
									<path
										className="fill-teal-500"
										fillOpacity=".24"
										d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0Z"
									/>
									<path
										className="fill-teal-400"
										fillRule="nonzero"
										d="M13 6.586 14.414 8l-5.747 5.748-3.081-3.081L7 9.252l1.667 1.667z"
									/>
								</svg>
								<p className="text-sm text-slate-400">
									{t('features6.card2.text')}
								</p>
							</div>
						</div>
						{/* Card #3 */}
						<div className="rounded-3xl border border-slate-800 bg-gradient-to-tr from-slate-800/50 to-slate-800/10">
							<div className="flex h-full items-center space-x-4 p-4">
								<svg
									className="shrink-0"
									xmlns="http://www.w3.org/2000/svg"
									width="20"
									height="20"
								>
									<path
										className="fill-teal-500"
										fillOpacity=".24"
										d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0Z"
									/>
									<path
										className="fill-teal-400"
										fillRule="nonzero"
										d="M13 6.586 14.414 8l-5.747 5.748-3.081-3.081L7 9.252l1.667 1.667z"
									/>
								</svg>
								<p className="text-sm text-slate-400">
									{t('features6.card3.text')}
								</p>
							</div>
						</div>
						{/* Card #4 */}
						<div className="rounded-3xl border border-slate-800 bg-gradient-to-tr from-slate-800/50 to-slate-800/10">
							<div className="flex h-full items-center space-x-4 p-4">
								<svg
									className="shrink-0"
									xmlns="http://www.w3.org/2000/svg"
									width="20"
									height="20"
								>
									<path
										className="fill-teal-500"
										fillOpacity=".24"
										d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0Z"
									/>
									<path
										className="fill-teal-400"
										fillRule="nonzero"
										d="M13 6.586 14.414 8l-5.747 5.748-3.081-3.081L7 9.252l1.667 1.667z"
									/>
								</svg>
								<p className="text-sm text-slate-400">
									{t('features6.card4.text')}
								</p>
							</div>
						</div>
						{/* Card #5 */}
						<div className="rounded-3xl border border-slate-800 bg-gradient-to-tr from-slate-800/50 to-slate-800/10">
							<div className="flex h-full items-center space-x-4 p-4">
								<svg
									className="shrink-0"
									xmlns="http://www.w3.org/2000/svg"
									width="20"
									height="20"
								>
									<path
										className="fill-teal-500"
										fillOpacity=".24"
										d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0Z"
									/>
									<path
										className="fill-teal-400"
										fillRule="nonzero"
										d="M13 6.586 14.414 8l-5.747 5.748-3.081-3.081L7 9.252l1.667 1.667z"
									/>
								</svg>
								<p className="text-sm text-slate-400">
									{t('features6.card5.text')}
								</p>
							</div>
						</div>
						{/* Card #6 */}
						<div className="rounded-3xl border border-slate-800 bg-gradient-to-tr from-slate-800/50 to-slate-800/10">
							<div className="flex h-full items-center space-x-4 p-4">
								<svg
									className="shrink-0"
									xmlns="http://www.w3.org/2000/svg"
									width="20"
									height="20"
								>
									<path
										className="fill-teal-500"
										fillOpacity=".24"
										d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0Z"
									/>
									<path
										className="fill-teal-400"
										fillRule="nonzero"
										d="M13 6.586 14.414 8l-5.747 5.748-3.081-3.081L7 9.252l1.667 1.667z"
									/>
								</svg>
								<p className="text-sm text-slate-400">
									{t('features6.card6.text')}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
